import { ISelectOption } from 'ui-toolkit';
import { eUSAState, States } from '../../ui-toolkit/enums/states';

export enum eContactAdditionalStateOptions {
  AllStates = 'ALL_STATES',
  AllOtherStates = 'ALL_OTHER_STATES',
}

export type IContactUSAStates = eContactAdditionalStateOptions | eUSAState;

export const clientUSAStateOptions: ISelectOption[] = [
  {
    label: 'All States',
    value: eContactAdditionalStateOptions.AllStates,
  },
  {
    label: 'All Other States',
    value: eContactAdditionalStateOptions.AllOtherStates,
  },
  ...States.map((s) => ({ value: s.Short, label: s.Long })),
];
